import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Navigation from '../components/Navigation';
import { PersonalService } from '../services/personalService';
import '../styles/pages/personal.css';

const AREAS = ['Recepción', 'Veterinaria', 'Estética', 'Guardería', 'Administración', 'Transporte'];
const CONTRATOS = ['Indefinido', 'Determinado', 'Por obra'];

const EMPTY = {
    nombre: '', curp: '', rfc: '', nss: '', nacimiento: '',
    domicilio: '', tel: '', email: '', puesto: '', area: '',
    ingreso: '', tipoContrato: 'Indefinido',
};

export default function NuevoEmpleado() {
    const { authorizedFetch } = useAuth();
    const navigate = useNavigate();

    const [form, setForm] = useState(EMPTY);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    const set = (field, value) => setForm(prev => ({ ...prev, [field]: value }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.nombre || !form.puesto || !form.area || !form.ingreso) {
            setError('Nombre, puesto, área y fecha de ingreso son obligatorios.');
            return;
        }
        setSaving(true);
        setError('');
        try {
            const emp = await PersonalService.create(form, authorizedFetch);
            navigate(`/settings/personal/${emp._id}`);
        } catch (err) {
            setError('No se pudo guardar el empleado. Intenta de nuevo.');
            console.error(err);
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <Navigation />
            <div className="pe-container">
                <button className="pe-back-link" onClick={() => navigate('/settings/personal')}>
                    ‹ Directorio
                </button>

                <div className="pe-ph">
                    <div>
                        <h1 className="pe-ph-title">Alta de empleado</h1>
                        <p className="pe-ph-sub">Datos mínimos para crear el expediente</p>
                    </div>
                </div>

                {error && <div className="pe-toast error" style={{ marginBottom: 16 }}>{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="pe-form-card">
                        <h3>🪪 Datos personales</h3>
                        <div className="pe-field">
                            <label>Nombre completo *</label>
                            <input placeholder="Nombre(s) y apellidos" value={form.nombre} onChange={e => set('nombre', e.target.value)} />
                        </div>
                        <div className="pe-row2">
                            <div className="pe-field">
                                <label>CURP</label>
                                <input placeholder="18 caracteres" value={form.curp} onChange={e => set('curp', e.target.value)} />
                            </div>
                            <div className="pe-field">
                                <label>RFC</label>
                                <input placeholder="Con homoclave" value={form.rfc} onChange={e => set('rfc', e.target.value)} />
                            </div>
                        </div>
                        <div className="pe-row2">
                            <div className="pe-field">
                                <label>NSS (IMSS)</label>
                                <input placeholder="11 dígitos" value={form.nss} onChange={e => set('nss', e.target.value)} />
                            </div>
                            <div className="pe-field">
                                <label>Fecha de nacimiento</label>
                                <input type="date" value={form.nacimiento} onChange={e => set('nacimiento', e.target.value)} />
                            </div>
                        </div>
                        <div className="pe-field">
                            <label>Domicilio</label>
                            <textarea rows="2" placeholder="Calle, número, colonia, CP, ciudad" value={form.domicilio} onChange={e => set('domicilio', e.target.value)} />
                        </div>
                    </div>

                    <div className="pe-form-card">
                        <h3>📞 Contacto y puesto</h3>
                        <div className="pe-row2">
                            <div className="pe-field">
                                <label>Teléfono</label>
                                <input placeholder="10 dígitos" value={form.tel} onChange={e => set('tel', e.target.value)} />
                            </div>
                            <div className="pe-field">
                                <label>Correo</label>
                                <input type="email" placeholder="nombre@happytails.mx" value={form.email} onChange={e => set('email', e.target.value)} />
                            </div>
                        </div>
                        <div className="pe-row2">
                            <div className="pe-field">
                                <label>Puesto *</label>
                                <input placeholder="Ej. Recepcionista" value={form.puesto} onChange={e => set('puesto', e.target.value)} />
                            </div>
                            <div className="pe-field">
                                <label>Área *</label>
                                <select value={form.area} onChange={e => set('area', e.target.value)}>
                                    <option value="">Selecciona…</option>
                                    {AREAS.map(a => <option key={a}>{a}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="pe-row2">
                            <div className="pe-field">
                                <label>Fecha de ingreso *</label>
                                <input type="date" value={form.ingreso} onChange={e => set('ingreso', e.target.value)} />
                            </div>
                            <div className="pe-field">
                                <label>Tipo de contrato</label>
                                <select value={form.tipoContrato} onChange={e => set('tipoContrato', e.target.value)}>
                                    {CONTRATOS.map(c => <option key={c}>{c}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="pe-note info" style={{ marginBottom: 14 }}>
                        ℹ️ Los datos médicos, bancarios y de nómina se completan dentro del expediente una vez creado.
                    </div>

                    <div className="pe-btn-row">
                        <button type="button" className="pe-btn pe-btn-ghost" onClick={() => navigate('/settings/personal')}>
                            Cancelar
                        </button>
                        <button type="submit" className="pe-btn pe-btn-pri" disabled={saving}>
                            {saving ? 'Guardando…' : 'Guardar'}
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
}
